import { useMemo, useRef, useState } from 'react';
import constate from 'constate';

export type SbPanZoomListener = { time: EditorTime; cell: Index; clipId: CellClip };

const LISTENER = {
  time: 0,
  cell: 0,
  clipId: null,
};

const useSbPanZoomProvider = () => {
  const sbPanZoomListenerRef = useRef<SbPanZoomListener>(LISTENER);
  const [sbPanZoomListener, setSbPanZoomListener] = useState<SbPanZoomListener>(LISTENER);
  const staticPayload = useMemo(() => ({ sbPanZoomListenerRef, setSbPanZoomListener }), []);
  return { sbPanZoomListener, sbPanZoomListenerRef, staticPayload };
};

export const [SbPanZoomProvider, useSbPanZoomContext, useSbPamZoomListener] = constate(
  useSbPanZoomProvider,
  (state) => state,
  (state) => state.staticPayload
);
